module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","complete":"Abschließen","continue":"Weiter","details":"Details","products":"Artikel","signature":"Unterschrift"},"en":{"back":"Back","complete":"Complete","continue":"Continue","details":"Details","products":"Products","signature":"Signature"}}')
  delete Component.options._Ctor
}
